export default "__VITE_PUBLIC_ASSET__a6e7b377__"